module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verified == 'true'),
      expression: "verified=='true'"
    }]
  }, [_c('el-popover', {
    ref: "user-menu",
    attrs: {
      "placement": "bottom",
      "popper-class": "user-menu",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "part part__bottomline"
  }, [_c('p', [_vm._v(_vm._s(_vm.fullname))])]), _c('div', {
    staticClass: "part"
  }, [_c('a', {
    staticClass: "btn btn--text",
    attrs: {
      "href": _vm.assessmentsUrl
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Assessments")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBadge),
      expression: "showBadge"
    }],
    staticClass: "pull-right badge"
  }, [_vm._v(_vm._s(_vm.openAssessments))])]), _c('a', {
    staticClass: "btn btn--text",
    attrs: {
      "href": _vm.logoutUrl
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Sign out")]), _c('i', {
    staticClass: "pull-right fa fa-sign-out"
  })])])]), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:user-menu",
      arg: "user-menu"
    }],
    staticClass: "my-account pull-right"
  }, [_c('i', {
    staticClass: "fa fa-user-o"
  }), _c('span', {
    staticClass: "my-account pl-10"
  }, [_c('span', {
    staticClass: "mr-10"
  }, [_vm._v(_vm._s(_vm.fullname))]), _c('i', {
    staticClass: "fa fa-angle-down"
  })])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67761c90","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/my-account.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-67761c90","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/my-account.vue
// module chunks = 0